import { z } from 'zod';
import { UserIdSchema } from '../user/user';

export const AuthSessionSchema = z.object({
  userId: UserIdSchema,
  tokenUse: z.enum(['access', 'id']),
  groups: z.array(z.string()).default([]),
});

export type AuthSession = z.infer<typeof AuthSessionSchema>;
